import type { ChartData, ChartOptions } from "chart.js";

import { stringToColor } from "../../../../utils/getColor";

/**
 * Default color for goal progress when no outlook color is set
 */
const DEFAULT_GOAL_COLOR = "#3E90C1";

/**
 * Background color for the unfilled portion of the progress chart
 */
const UNFILLED_COLOR = "#E9EAEC";

/**
 * Generates Chart.js options for a goal progress doughnut chart
 */
export const getProgressChartOptions = (): ChartOptions<"doughnut"> => ({
	animation: false,
	events: [],
	plugins: {
		tooltip: {
			enabled: false,
		},
		legend: {
			display: false,
		},
	},
});

/**
 * Generates Chart.js data configuration for a goal progress doughnut chart
 * @param progress - Progress value between 0 and 1
 * @param color - Optional color string (hex or color name)
 */
export const getProgressChartData = (progress: number, color?: string): ChartData<"doughnut"> => {
	const percentComplete = Math.max(0, Math.min(1, progress || 0));
	const baseColor = color || DEFAULT_GOAL_COLOR;
	const chartColor = baseColor.startsWith("#") ? baseColor : stringToColor(baseColor);

	return {
		datasets: [
			{
				data: [percentComplete, 1 - percentComplete],
				backgroundColor: [chartColor, UNFILLED_COLOR],
				borderWidth: 0,
			},
		],
	};
};
